import { ArrowRight } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";
import VideoChatFrame from "./VideoChatFrame";

const FEATURES = [
  { label: "Real-time AI videochat", path: "/technology/real-time-ai-video" },
  { label: "Photorealistic AI avatars", path: "/technology/photorealistic-ai-characters" },
  { label: "Voice conversation", path: "/technology/ai-voice" },
  { label: "Conversational AI", path: "/technology/conversational-ai" },
  { label: "Emotional responses", path: "/technology/emotional-responses" },
  { label: "Facial expressions", path: "/technology/facial-expressions" },
  { label: "Natural movement", path: "/technology/natural-movement" },
  { label: "Interactive AI companions", path: "/technology/interactive-ai-companions" },
];

export default function Product() {
  return (
    <section id="technology" data-testid="product-section" className="relative py-16 lg:py-36">
      <div className="mx-auto grid max-w-7xl items-center gap-16 px-6 lg:grid-cols-2 lg:px-10">
        <div>
          <Reveal>
            <SectionTag>The Product</SectionTag>
            <h2 className="font-display mt-5 text-3xl font-light tracking-tighter text-white sm:text-4xl lg:text-5xl">
              A New Way to <span className="text-cyan-300">Experience AI</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-[#C5CBD5]">
              AIROBOTCAMSTUDIO is developing a real-time visual and conversational AI experience.
              Instead of reading text on a screen, users will see, hear and talk with photorealistic
              AI characters that respond with natural voice, emotion, expression and movement.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 grid grid-cols-2 gap-3">
              {FEATURES.map(({ label, path }) => (
                <a
                  key={label}
                  href={path}
                  data-testid={`product-feature-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="group rounded-lg border border-cyan-300/15 bg-white/[0.03] px-4 py-3 transition-colors duration-300 hover:border-cyan-300/40"
                >
                  <span className="flex items-center justify-between gap-2 text-[13px] font-medium text-white/80 transition-colors duration-300 group-hover:text-white">
                    {label}
                    <ArrowRight
                      size={12}
                      className="shrink-0 text-cyan-300/70 transition-transform duration-300 group-hover:translate-x-0.5"
                    />
                  </span>
                  <span className="mt-1 block text-[9px] font-semibold uppercase tracking-[0.18em] text-cyan-300/60">
                    Learn more
                  </span>
                </a>
              ))}
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.15} className="mx-auto w-full max-w-md">
          <VideoChatFrame
            src="/assets/product_companion.jpg"
            name="AIDEN"
            caption="Concept visual — experience in development"
          />
        </Reveal>
      </div>
    </section>
  );
}
